import * as C from './constants'

export const routeInit = () => ({ type: C.ROUTE_INIT })
export const routeChangeStart = () => ({ type: C.ROUTE_CHANGE_START })
export const routeChangeComplete = (nae) => ({ type: C.ROUTE_CHANGE_COMPLETE })
export const routeChangeError = () => ({ type: C.ROUTE_CHANGE_ERROR })
export const beforeHistoryChange = () => ({ type: C.BEFORE_HISTORY_CHANGE })
export const hashChangeStart = () => ({ type: C.HASH_CHANGE_START })
export const hashChangeComplete = () => ({ type: C.HASH_CHANGE_COMPLETE })
